// removed by extract-text-webpack-plugin
module.exports = {"name":"c-ProductName__name","link":"c-ProductName__link","big":"c-ProductName__big","noClickable":"c-ProductName__noClickable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/ProductName/ProductName.scss
// module id = 511
// module chunks = 0